/**
 * The web app pages that finish the same emailed links. config-backend builds these links for a Lookout sign-up
 * while Lookout's own sign-in is off, so the web app accepts the same token.
 */

function base(webAppUrl: string): string {
  return webAppUrl.replace(/\/+$/, '');
}

/** The web app's page that finishes a sign-up. A Lookout sign-up always gets the Free Tier plan. */
export function webAppSignupLink(webAppUrl: string, token: string): string {
  const params = new URLSearchParams({ token, type: 'freetrial', redirectTo: 'lookout' });
  return `${base(webAppUrl)}/esignup?${params.toString()}`;
}

/** The web app's page that sets a new password. */
export function webAppResetLink(webAppUrl: string, token: string): string {
  return `${base(webAppUrl)}/forgotPassword?${new URLSearchParams({ token }).toString()}`;
}
